// hr
// export const MAIN_URL = 'https://ns.rasahr.ir/api/'
// export const SITE_ADDRESS = 'https://test.exhibitionmakers.com'

export const MAIN_URL = 'https://form.exhibitionmakers.com/api/'
export const SITE_ADDRESS = 'https://exhibitionmakers.com'
